import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"

export default class extends Controller {
  static values = {
    settings: Object,
  }

  connect() {
    this.slimselect = new SlimSelect({
      select: this.element,
      settings: { ...this.settingsValue },
      events: this.events(),
    })
  }

  disconnect() {
    this.slimselect.destroy()
  }

  events() {
    return null
  }
}
